import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Bredcom from "../components/Bredcom/Bredcom";
import InTouch from "../components/Kontakt/InTouch";
import Map from "../components/Kontakt/Map";
import Form from "../components/Kontakt/Form";
import Footer from "../components/Footer/Footer";

function Main() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Kontakt" />
      <InTouch />
      <Map />
      <Form />
      <Footer />
    </>
  );
}

export default Main;
